export default "__VITE_ASSET__DqPPtCtf__"